import React from 'react'
import { graphql } from 'gatsby'
import { Box, Heading, Text } from 'rebass/styled-components'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Container from '../components/container'

const PrivacyPage = ({ data }) => (
  <Layout hideMenuToggle showSecondaryLogo>
    <SEO
      title="Ochrana soukromí"
      description="Zásady ochrany soukromí Acrebond a.s."
    />

    <Box sx={{ py: 6 }}>
      <Container>
        <Heading as="h1" sx={{ mb: 5, color: 'primary', fontSize: 6 }}>
          Ochrana soukromí
        </Heading>

        <Text
          variant="body"
          dangerouslySetInnerHTML={{ __html: data.privacy.html }}
        />
      </Container>
    </Box>
  </Layout>
)

export default PrivacyPage

export const pageQuery = graphql`
  {
    privacy: markdownRemark(frontmatter: { slug: { eq: "privacy" } }) {
      frontmatter {
        title
      }
      html
    }
  }
`
